'use client';

import React, { useState } from 'react';
import NavBar from '@/components/header/NavBar';
import AnimatedCopy from '@/components/home-page/AnimatedCopy';
import Image from "next/image";

import Why from '@/components/home-page/whySection';
import ContactForm from '@/components/home-page/ContactForm';
import FAQContainer from '@/components/home-page/FAQContainer';
import Footer from '@/components/footer/Footer';


const ContactForms: React.FC = () => {




  return (
  
  <>
  {/* Fixed background — stays behind everything while page scrolls */}

  <div
    className="bg-cover bg-center bg-no-repeat h-96 lg:h-[500px] relative"
    style={{ backgroundImage: `url('/hero/1.avif')` }}
  >
   
<div className="absolute inset-0 bg-secondary/55 h-96 lg:h-[500px] " />
  <h1 className="absolute inset-0 flex items-center pt-20 lg:pt-40 justify-center text-white text-5xl lg:text-9xl font-extrabold text-center px-4 ">
    UI/UX Design
  </h1>
    
  </div>

  <NavBar />

  <section className="about-me-copy  bg-secondary">
          <div className="about-me-copy-wrapper">
            <h2 className='text-primary text-3xl lg:text-6xl py-8'>
              Great UI/UX isn't decoration, it's strategy. We design digital
              products that feel effortless and are built to convert.
            </h2>

          </div>
        </section>

        <section className="services">
 <div className="services-col">
  <div className="services-banner">
    <Image
      src="/hero/ui.avif"
      alt=""
      fill
      style={{ objectFit: "cover" }}
      sizes="(max-width: 768px) 100vw, 50vw"
    />
  </div>
</div>
          <div className="services-col ">
            <h4 className='text-2xl lg:text-3xl'>
              Every product we design starts with your users, not our
              portfolio. We combine research, interface design, and
              development expertise to build experiences that are as
              functional as they are beautiful.
            </h4>

            <div className="services-list">
              <div className="service-list-row">
                <div className="service-list-col">
                  <h5 className='text-2xl'>UX Research & Strategy</h5>
                </div>
                <div className="service-list-col md:text-lg lg:text-xl">
                  <p>
                    We start by understanding your users, your market, and
                    your goals. Through user interviews, competitor analysis,
                    and journey mapping, we uncover exactly what your product
                    needs to succeed — before a single pixel is placed.
                  </p>
                </div>
              </div>

              <div className="service-list-row">
                <div className="service-list-col">
                  <h5 className='text-2xl'>UI Design & Prototyping</h5>
                </div>
                <div className="service-list-col md:text-lg lg:text-xl">
                  <p>
                    Clean layouts, purposeful typography, and interfaces that
                    guide users naturally toward action. We design
                    high-fidelity, interactive prototypes so you can see and
                    test the experience before development begins.
                  </p>
                </div>
              </div>

              <div className="service-list-row">
                <div className="service-list-col">
                  <h5 className='text-2xl'>Design Systems & Handoff</h5>
                </div>
                <div className="service-list-col md:text-lg lg:text-xl">
                  <p>
                    We build scalable design systems — reusable components,
                    consistent styling, and clear documentation — so your
                    product stays cohesive as it grows, and our developers
                    can build it exactly as designed, pixel for pixel.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

<Why/>
<ContactForm/>

<FAQContainer
  title={"UI/UX Design\nFAQs"}
  description="Answers to the most common questions clients ask about our UI/UX design process, timelines, and deliverables."
  faq={[
  {
    question: "What's included in your UI/UX design service?",
    answer:
      "We handle UX research, wireframing, high-fidelity UI design, interactive prototyping, and a full design system handoff for development.",
  },
  {
    question: "Do I get to see designs before development starts?",
    answer:
      "Yes — you'll review and approve interactive prototypes before any code is written, so there are no surprises later.",
  },
  {
    question: "How long does a UI/UX design project take?",
    answer:
      "Most projects take 2–6 weeks depending on scope, from initial research through final design handoff.",
  },
  {
    question: "Will the designs match my brand?",
    answer:
      "Absolutely. We build a design system around your brand's colors, typography, and voice so everything feels consistent.",
  },
  {
    question: "Do you offer revisions if I don't like the designs?",
    answer:
      "Yes — every project includes revision rounds so we can fine-tune the design together until it feels right.",
  },
  {
    question: "What tools do you use for UI/UX design?",
    answer:
      "We primarily design in Figma, giving you easy access to view, comment on, and collaborate on the designs in real time.",
  },
]}
/>
<Footer/>
</>
  );
};

export default ContactForms;